import React, {useEffect, useState} from 'react';
import {
    Box,
    Button,
    IconButton,
    Grid,
    Modal,
    ModalActions,
    ModalContent,
    ModalTitle,
    InputLabel, Input, FormControl, InputAdornment, FormHelperText, Alert, useToastProvider, Typography, Link
} from "@deere/fuel-react";
import {
    DOWNLOAD_TEMPLATE,
    FILE_UPLOAD_TEXT_TITLE,
    LAST_UPLOADED_DATE,
    UPLOAD_DATA, UPLOAD_QUANTITATIVE_DATA
} from "../Constants";
import PublishIcon from '@material-ui/icons/Publish';
import {useAuthConfig} from "../helper";
import {Loading} from "../Loading";

export const UploadCriteriaDataModal = () => {
    let authAxios = useAuthConfig();
    const {enqueueToast} = useToastProvider();
    const [open, setOpen] = useState(false);
    const [error, setError] = useState(false);
    const [uploadError, setUploadError] = useState(false);
    const [isUploadEnable, setIsUploadEnable] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [uploadErrorArr, setUploadErrorArr] = useState([]);
    const [selectedFile, setSelectedFile] = useState();
    const [lastUploadedDate, setLastUploadedDate] = useState();

    const resetState = () => {
        setError(false);
        setUploadError(false);
        setUploadErrorArr([]);
        setIsLoading(false);
        setIsUploadEnable(false);
        setOpen(false);
    };

    const handleClickOpen = () => {
        setOpen(true);
        fetchLastUploadDate();
    };

    const isValidFileExtension = (fileName) => {
        const ext = ['.csv'];
        return ext.some(el => fileName.endsWith(el));
    }

    const handleUpload = (e) => {
        setError(false)
        setUploadError(false)
        setUploadErrorArr([]);
        console.log(e.target.files[0])
        if (e.target.files[0] && isValidFileExtension(e.target.files[0].name)) {
            setIsUploadEnable(true)
            setSelectedFile(e.target.files[0])
        } else {
            setIsUploadEnable(false)
            setSelectedFile(null)
            setError(true)
        }
    };

    const handleClose = () => {
        resetState()
    };

    const handleSave = () => {
        setIsLoading(true)
        let formData = new FormData();
        formData.append("file", selectedFile);

        authAxios.post(`/uploadQuantitativeData`, formData , {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        })
            .then(res => {
                enqueueToast({
                    variant: "success",
                    title: "Data Uploaded successfully",
                    isCloseable: true
                });
                resetState()
            }).catch((error) => {
            setIsLoading(false)
            if (error.response && error.response.data[error.response.status])
                setUploadErrorArr(error.response.data[error.response.status].split(";"))

            setUploadError(true);
            setOpen(true);
        });
        setError(false)
    }

    const getLastUploadDate = async () => {
        try {
            return await authAxios.get(`/lastUploadDate`)
        } catch (e) {
            console.error(e);
            enqueueToast({
                variant: "error",
                title: "Error fetching last uploaded date",
                isCloseable: false
            });
        }
    };

    const fetchLastUploadDate = () => {
        getLastUploadDate().then(res => {
            setLastUploadedDate(res.data)
        }).catch((error) => {
            console.log(error)
        });
    }

    useEffect(() => {
        return () => {
            resetState()
        } // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div>
            <Button variant="secondary" startIcon={<PublishIcon/>} onClick={handleClickOpen}>
                {UPLOAD_DATA}
            </Button>
            <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="alert-Modal-title"
                aria-describedby="alert-Modal-description"
                maxWidth="sm"
                fullWidth={true}
            >
                <ModalTitle onClose={handleClose} id="alert-Modal-title">
                    {UPLOAD_QUANTITATIVE_DATA}
                    <Typography color="secondary" size="sm">
                        {LAST_UPLOADED_DATE}: {lastUploadedDate}
                    </Typography>
                </ModalTitle>
                <ModalContent>
                    <Grid container alignItems="center" spacing={2}>
                        <Grid item xs={12}>
                            <FormControl fullWidth required error={error}>
                                <InputLabel htmlFor="uploadFile" style={{paddingBottom: '.5rem'}}>
                                    {FILE_UPLOAD_TEXT_TITLE}
                                </InputLabel>
                                <Input fullWidth
                                       placeholder="FILE PATH"
                                       id="uploadFile"
                                       type="file"
                                       inputProps={
                                           {
                                               accept: ".csv",
                                               style: {paddingTop: '0.5rem'}
                                           }
                                       }
                                       endAdornment={
                                           <InputAdornment position="end">
                                               <IconButton aria-label="publish" style={{paddingTop: ".6rem"}}>
                                                   <PublishIcon/>
                                               </IconButton>
                                           </InputAdornment>
                                       }
                                       onChange={(e) => {
                                           handleUpload(e)
                                       }}/>
                            </FormControl>
                            <FormHelperText error={error}>{error && "Select a .CSV file"}</FormHelperText>
                        </Grid>
                        <Grid item xs={12}>
                            <Box p={2}>
                                {isLoading && (
                                    <Loading/>
                                )}
                                {!isLoading && uploadError && (
                                    <Alert variant="error" title="Error while uploading the file">
                                        <ul>
                                            {uploadErrorArr.length > 0 && uploadErrorArr.map((item, index) => {
                                                return (
                                                    <>
                                                        {item !== "" &&
                                                        <li key={index}>
                                                            {item}
                                                        </li>
                                                        }
                                                    </>
                                                )
                                            })}
                                        </ul>
                                    </Alert>
                                )}
                            </Box>
                        </Grid>
                    </Grid>
                </ModalContent>
                <ModalActions>
                    <Grid container>
                        <Grid item xs={12}>
                            <Box display="flex" justifyContent="flex-end">
                                <Box m={2}>
                                    <Link href="AE-Mass-Data.csv" download style={{textDecoration: "none"}}>
                                        {DOWNLOAD_TEMPLATE}
                                    </Link>
                                </Box>
                                <Box mr={2}>
                                    <Button onClick={handleClose} variant="secondary">
                                        Cancel
                                    </Button>
                                </Box>
                                <Button onClick={handleSave} variant="primary" disabled={!isUploadEnable}>
                                    Upload
                                </Button>
                            </Box>
                        </Grid>
                    </Grid>
                </ModalActions>
            </Modal>
        </div>
    );
};
